<div class="acc-progress-by-section-view-part">
	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="progressBySection()"></grid-content>
</div>